import {CreateInstance} from './config'
const tableColumnDataReturnAPI = CreateInstance('column_return')
export default tableColumnDataReturnAPI